import React from 'react';
import { FaGithub, FaLinkedin, FaInstagram, FaTiktok, FaFacebook } from 'react-icons/fa';
import './About.css';

const About = () => {
  
  return (
    <div className="about-container"> 
      {/* Profile Section */}
      <div className="profile-section" style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <div className="profile-info">
          <img 
            src="/avatar_new.jpg"
            alt="Profile"
            style={{ width: '150px', height: '150px', borderRadius: '50%', objectFit: 'cover', margin: '0 auto' }}
          />
          <h1>Tào Việt Đức</h1>
          <p className="title">Full Stack Developer & Content Creator</p>
          <p class="info">Age: 22 | Location: Ho Chi Minh City, Vietnam</p>
          <p class="info">Email: taovietduc.work@gmail.com</p>
          <p class="info">Languages: Vietnamese (Native), English (Professional)</p>
          <div className="social-links" style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', gap: '2.5rem' }}>
            <a href="https://github.com/taovietducofficial" target="_blank" rel="noopener noreferrer">
              <FaGithub size={24} />
            </a>
            <a href="https://www.linkedin.com/in/taovietduc19/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={24} />
            </a>
            <a href="https://www.instagram.com/taovietduc_" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={24} />
            </a>
            <a href="https://www.tiktok.com/@taovietduc_" target="_blank" rel="noopener noreferrer">
              <FaTiktok size={24} />
            </a>
            <a href="https://www.facebook.com/taovietduc.official" target="_blank" rel="noopener noreferrer">
              <FaFacebook size={24} />
            </a>
          </div>
        </div>
      </div>

      {/* Education Section */}
      <div className="education-section">
        <h2 style={{ marginBottom: '1rem' }}>Education</h2>
        <div>
          <h3 class="info" >Ho Chi Minh City University of Technology and Education</h3>
          <p class="info">Information System</p>
          <p class="info" >GPA: 3.25/4.0 | TOEIC: 705/990</p>
        </div>
      </div>

      <div className="education-section" >
        <h2 style={{ marginBottom: '1rem' }}>Career Goals</h2>
        <div className="canvas-card">
          <p class="info">Currently excelling as a Frontend Developer while actively pursuing Full Stack Development expertise. Passionate about creating innovative solutions and sharing knowledge through content creation.</p>
          <p class="info">Short-term: Master modern web technologies and expand technical leadership skills</p>
          <p class="info">Long-term: Lead major tech projects and inspire next-generation developers</p>
        </div>
      </div>

      {/* Bottom Row: Information Technology and Media Development */}
      <div className="bottom-row" style={{ display: 'flex', gap: '3rem' }}>
        {/* Information Technology Section */}
        <div className="info-tech-section" >
          <h2 >Information Technology Experience</h2>
          <div class="info">
            <h3>Data Engineer & Software Engineer</h3>
            <p>HCMC University of Technology and Education</p>
          </div>
          <div class="info">
            <h3>Founder @ CODE4LIFE</h3>
            <p>January 2024 - Present</p>
            <p>• 20,000+ followers on social media platforms</p>
            <p>• Leadership and Full-Stack Development</p>
          </div>
          <div class="info">
            <h3>Programming Tutor @ FUNiX</h3>
            <p>June 2024 - Present</p>
            <p>• Teaching and Programming</p>
          </div>
          <div class="info">
            <h3>AWS Academy Cloud Foundations Certificate</h3>
            <p>CT University AWS Academy</p>
            <p>September 2023 - September 2025</p>
          </div>
          <div class="info">
            <h3>Ambassador @ AIESEC in Vietnam</h3>
            <p>June 2023 - July 2025</p>
            <p>• Heading for the Future Vietnam (H4TF) project</p>
            <p>• Code-end Run competition focused on algorithms</p>
            <p>• Supporting students with practical experience through workshops and competitions</p>
          </div>
        </div>

        {/* Media Development Section */}
        <div className="media-dev-section" >
          <h2 >Digital Media & Content Creation</h2>
          <div class="info">
            <h3>Social Media Content Creator</h3>
            <p>140,000+ followers across platforms</p>
          </div>
          <div class="info">
            <h3>Instagram</h3>
            <p>Content Creator - Personal Branding</p>
            <p>May 2023 - Present | 70,000+ followers</p>
            <p>• Data Analysis and Content Creation</p>
            <p>• Personal Branding Skills</p>
          </div>
          <div class="info">
            <h3>TikTok</h3>
            <p>Content Creator - Personal Branding</p>
            <p>May 2023 - Present | 40,000+ followers</p>
            <p>• Data Analysis and Content Creation</p>
            <p>• Personal Branding Skills</p>
          </div>
          <div class="info">
            <h3>Threads</h3>
            <p>Content Creator - Personal Branding</p>
            <p>October 2023 - Present | 22,000+ followers</p>
            <p>• Data Analysis • Content Creation • Personal Branding Skills</p>
          </div>
          <div class="info">
            <h3>eTeacher.vn - Gia sư Đỉnh cao</h3>
            <p>Tutor & Content Creator - Brand Face</p>
            <p>July 2022 - October 2023</p>
            <p>• Teaching • Content Creation • Personal Branding</p>
            <p>• Data Analysis</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
